import React, { useState } from 'react'
import messages from './messages'
import { useIntl, FormattedMessage } from 'react-intl'
import { Modal, Button } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

export default NiceModal.create(({ task, order }) => {
  const [loading, setLoading] = useState(false)
  const { formatMessage } = useIntl()
  const modal = useModal()

  const onSubmit = (event) => {
    event.preventDefault()
    setLoading(true)

    const body = new FormData()
    body.append('taskId', task.uid)

    fetch(`/ordertask/approveallfiles.html`, { method: 'POST', body })
      .then((response) => response.text())
      .then((response) => {
        setLoading(false)

        if (response !== 'OK') {
          toastr.error('Something went wrong. Please try again.')
        } else {
          modal.resolve()
          modal.remove()
        }
      })
      .catch((error) => toastr.error(error))
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      title={formatMessage(messages.title)}
    >
      <form className="space-y-8" onSubmit={onSubmit} disabled={loading}>
        <ol className="list-decimal list-inside text-sm">
            <FormattedMessage
              {...messages.sideEffects}
              values={{
                li: (chunks) => <li className="">{chunks}</li>,
              }}
            />
        </ol>

        <div className="flex justify-end items-center space-x-2">
          <Button type="submit" size="sm" disabled={loading}>
            { loading ? (
              <FormattedMessage {...messages.loading} />
            ) : (
              <FormattedMessage {...messages.submit} />
            ) }
          </Button>

          <Button type="button" size="sm" onClick={() => modal.remove()} variant="outline">
            <FormattedMessage {...messages.cancel} />
          </Button>
        </div>
      </form>
    </Modal>
  )
})
